import React from 'react';
import Base from './Base';

export default React.createClass({
    propTypes: {
        urls: React.PropTypes.object.isRequired,
        i18n: React.PropTypes.object,
        profilePhotoPlaceholderUrl: React.PropTypes.string.isRequired
    },
    getInitialState() {
        return {
            loading: true,
            loadingMore: false,
            error: false,
            errorLoadingMore: false,
            data: false
        };
    },
    componentWillMount() {
        this.serverRequest = $.get(this.props.urls.get, (result) => {
            if (result.Timelines) {
                this.setState({
                    loading: false,
                    data: result
                });
            } else {
                this.setState({
                    loading: false,
                    error: true
                });
            }
        }).fail(() => {
            this.setState({
                loading: false,
                error: true
            });
        });
    },
    componentWillUnmount: function() {
        this.serverRequest.abort();
    },
    handleLoadMoreItems: function() {
        this.setState({
            loadingMore: true,
            errorLoadingMore: false
        });

        this.serverRequest = $.get(this.props.urls.get, { offset: this.state.data.Timelines.length }, (result) => {
            if (result.Timelines) {
                let newData = result;
                let newTimelines = result.Timelines;
                let oldTimelines = this.state.data.Timelines;
                newData.Timelines = oldTimelines.concat(newTimelines);

                this.setState({
                    data: newData,
                    loadingMore: false
                });
            } else {
                this.setState({
                    loadingMore: false,
                    errorLoadingMore: true
                });
            }
        }).fail(()  => {
            this.setState({
                loadingMore: false,
                errorLoadingMore: true
            });
        });
    },
    render() {
        if (this.state.loading) {
            return (
                <div>
                    <div className="c-module">
                        <div className="c-spinner">{this.props.i18n.loading}</div>
                    </div>
                </div>
            );
        } else if (!this.state.data) {
            return (
                <div>
                    {this.props.i18n.error}
                </div>
            );
        } else {
            const loadingClass = (this.state.loadingMore) ? 'is-loading': '';

            return (
                <div className="c-timeline">
                    {this.state.data.Timelines.map((model, idx) => {
                        model.Content = model.Content || false;
                        return <Base
                            key={idx}
                            id={model.Id}
                            secureid={model.SecureId}
                            likes={model.Likes}
                            likedByMe={model.LikedByMe}
                            isMyTimeline={model.IsMyTimeline}
                            type={model.TimelineType}
                            urls={this.props.urls}
                            text={model.Text}
                            created={model.CreatedSince}
                            content={model.Content}
                            shareUrl={model.ShareUrl}
                            imageUrl={model.ImageUrl}
                            photoUrl={model.PhotoUrl || this.props.profilePhotoPlaceholderUrl}
                            detailUrl={model.DetailUrl}
                        />;
                    })}
                    {this.state.data.HasNextPage &&
                        <button className={`c-button c-button--secondary c-timeline__more ${loadingClass}`} onClick={this.handleLoadMoreItems} disabled={this.state.loadingMore ? "disabled" : false}>
                            <span>{this.state.loadingMore ? this.props.i18n.loadingMore : (this.state.errorLoadingMore) ? this.props.i18n.errorLoadingMore : this.props.i18n.more}</span>
                        </button>
                    }
                </div>
            );
        }
    }
});
